import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    },
});

const SHARE_PERMISSION_MAP = {
    'readonly-hidden': 'Invisible',
    'readonly-visible': 'Read',
    editor: 'Edit',
};

const SharesTab = props => {
    const { classes, shares = [] } = props;

    return (
        <div className={classes.container}>
            <Typography variant="subtitle2">
                This group is part of the following shares:
            </Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '72%', fontWeight: 'bold' }}>
                            Name
                        </TableCell>
                        <TableCell style={{ width: '24%', fontWeight: 'bold' }}>
                            Permissions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {shares.map((share, index) => (
                        <TableRow key={index}>
                            <TableCell align="left">
                                {share.batch__nickname}
                            </TableCell>
                            <TableCell align="left">
                                {SHARE_PERMISSION_MAP[share.permissions]}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default withStyles(styles)(SharesTab);
